import type React from "react";
import { Box, IconButton, Button, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { KeyboardArrowLeft } from "@mui/icons-material";
import figmabackground from "../../../assets/figma-design-header.png";
import { useNavigate } from "react-router-dom";

interface HeaderProps {
  onAddDesignClick: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onAddDesignClick }) => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        position: "relative",
        height: 380,
        backgroundImage: `url(${figmabackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 6,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 40,
          left: 48,
          right: 48,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          zIndex: 2,
        }}
      >
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <IconButton
            onClick={() => navigate(-1)}
            sx={{
              width: 48,
              height: 48,
              borderRadius: 4,
              border: "3px solid white",
              color: "white",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.1)",
              },
            }}
          >
            <KeyboardArrowLeft fontSize="large" />
          </IconButton>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Button
            onClick={onAddDesignClick}
            sx={{
              backgroundColor: "#fff",
              color: "#000",
              px: 3.5,
              py: 2,
              fontWeight: 600,
              borderRadius: 2,
              boxShadow: "0px 8px 24px rgba(0,0,0,0.25)",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            Add New Design
          </Button>
        </motion.div>
      </Box>

      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          mt: 14,
          ml: 6,
        }}
      >
        <Typography
          sx={{
            color: "white",
            letterSpacing: "0.35em",
            fontSize: 14,
            mb: 1.5,
          }}
        >
          MUZUKURU
        </Typography>

        <Typography
          sx={{
            color: "white",
            fontWeight: 900,
            fontSize: 80,
            lineHeight: "100%",
          }}
        >
          Design
        </Typography>

        <Typography
          sx={{
            color: "white",
            fontWeight: 900,
            fontSize: 80,
            lineHeight: "100%",
          }}
        >
          Gallery
        </Typography>
      </Box>
    </Box>
  );
};
